import { AssetsResultProps, useEditor } from "@grapesjs/react";
import {
  Box,
  Button,
  Grid,
  Image,
  Stack,
  useMantineTheme,
} from "@mantine/core";
import { SupportedMediaType } from "~/../../communities-app/lib/components/ContentFeed/TextEditor/types";

import { BuilderMediaUploader } from "./BuilderMediaUploader";

export const CustomAssetManager = (props: AssetsResultProps) => {
  const { assets, select } = props;
  const editor = useEditor();
  const theme = useMantineTheme();
  // const [uploadedAsset, setUploadedAsset] = useState<string | null | undefined>(
  //   undefined
  // );

  const handleOnMediaChanged = (
    media?: { url: string; type: string } | null
  ) => {
    if (media == null) return;

    console.log("media", media);
    // setUploadedAsset(media.url);
    editor.AssetManager.add({
      src: media.url,
      type: media.type,
    });
  };

  return (
    <Stack>
      <BuilderMediaUploader
        mediaUrl={undefined}
        mediaType={SupportedMediaType.IMAGE}
        onMediaChanged={handleOnMediaChanged}
        mediaError={""}
        edited={undefined}
      />

      <Box
        sx={{
          flex: 1,
          minHeight: 200,
          maxHeight: 600,
          overflow: "auto",
        }}
      >
        <Grid align="center" gutter={32}>
          {assets.map((asset) => {
            return (
              <Grid.Col span={4} key={asset.id}>
                <Stack
                  justify="center"
                  align="center"
                  spacing={8}
                  sx={{
                    position: "relative",
                  }}
                >
                  <Image
                    src={asset.getSrc()}
                    width={200}
                    height={200}
                    sx={{
                      borderRadius: 8,
                      overflow: "hidden",
                      background: theme.colors.gray[1],
                      cursor: "pointer",
                      // padding: 8,
                    }}
                    imageProps={{
                      style: {
                        height: 200,
                        width: 200,
                        objectFit: "contain",
                      },
                    }}
                    onClick={() => {
                      select(asset, true);
                    }}
                  />

                  <Button
                    onClick={() => {
                      editor.Assets.remove(asset);
                    }}
                    sx={{
                      position: "absolute",
                      left: "50%",
                      bottom: 8,
                      transform: "translateX(-50%)",
                    }}
                  >
                    remove
                  </Button>
                </Stack>
              </Grid.Col>
            );
          })}

          {/* <Grid.Col span={3} style={{ minHeight: 80 }}>
          1
        </Grid.Col>
        <Grid.Col span={3} style={{ minHeight: 120 }}>
          2
        </Grid.Col>
        <Grid.Col span={3}>3</Grid.Col> */}
        </Grid>
      </Box>
    </Stack>
  );
};
